/* ROSÉE — page panier (sections/rs-panier-page.liquid).
   Formule : remplace la ligne par le lot choisi = variante unité × q depuis le 24/10/2026 (jamais deux lots du même produit).
   Quantité / retrait : /cart/change.js. Accessoire : /cart/add.js (le tracker CRO compte l'ajout).
   Après chaque appel, la section est re-rendue par le serveur (paramètre sections). */
(function () {
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function bloc() { return document.getElementById('rs-panier'); }

  function appel(chemin, corps) {
    var b = bloc();
    if (!b) return;
    var id = b.getAttribute('data-section');
    corps.sections = id;
    corps.sections_url = window.location.pathname + window.location.search;
    b.classList.add('rp-occupe');
    return fetch(racine + chemin, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corps)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (rep) {
      var html = rep && rep.sections && rep.sections[id];
      if (!html) { location.reload(); return; }
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var neuf = tmp.querySelector('#rs-panier');
      if (neuf) bloc().replaceWith(neuf); else location.reload();
      majCompteur();
    }).catch(function () { location.reload(); });
  }

  // Pastille du panier dans l'en-tête du thème.
  function majCompteur() {
    fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-totalqty]').forEach(function (el) { el.setAttribute('data-totalqty', c.item_count); });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!bloc() || !bloc().contains(e.target)) return;
    var f = e.target.closest('[data-rp-lot]');
    if (f) {
      if (f.classList.contains('rp-f-on') || f.disabled) return;
      // Lots en quantité (24/10/2026, snippets/rs-lots) : la formule q = la variante unité × q.
      var cle = f.getAttribute('data-rp-cle'), lot = f.getAttribute('data-rp-lot');
      var m = (window.rsLots || {})[lot] || [lot, 1];
      if (+cle.split(':')[0] === +m[0]) { appel('cart/change.js', { id: cle, quantity: m[1] }); return; }
      var u = {};
      u[cle] = 0;
      u[m[0]] = m[1];
      appel('cart/update.js', { updates: u });
      return;
    }
    var q = e.target.closest('[data-rp-qte]');
    if (q) {
      appel('cart/change.js', { id: q.getAttribute('data-rp-cle'), quantity: Math.max(0, +q.getAttribute('data-rp-qte') || 0) });
      return;
    }
    var a = e.target.closest('[data-rp-ajout]');
    if (a) {
      appel('cart/add.js', { items: [{ id: +a.getAttribute('data-rp-ajout'), quantity: 1 }] });
    }
  });
})();
